import {IStateGift} from './reducer';
import {
  createAction,
  createActionFetch,
  createBasicActions,
} from '../../common/util/redux';
import {IGiftType} from '../type';

export enum ActionType {
  SetValue = 'gift.SetValue',
  SetPropertyValues = 'gift.SetPropertyValues',
  FetchGifts = 'gift.FetchGifts',
  FetchReceiveTicket = 'gift.FetchReceiveTicket',
  SetReceivedTicket = 'gift.SetReceivedTicket',
  RemoveExpiredTicket = 'gift.RemoveExpiredTicket',
  FetchGiftRedDotStatus = 'gift.FetchGiftRedDotStatus',
}

export const actions = {
  ...createBasicActions<IStateGift>({
    setValueActionType: ActionType.SetValue,
    setPropertyValuesActionType: ActionType.SetPropertyValues,
  }),
  fetchGifts: (tab: IGiftType) =>
    createActionFetch(ActionType.FetchGifts, {
      payload: {tab},
      fetchKey: tab,
    }),
  fetchReceiveTicket: (ticketId: number) =>
    createActionFetch(ActionType.FetchReceiveTicket, {
      payload: {ticketId},
      fetchKey: ticketId,
    }),
  setReceivedTicket: (ticketId: number) =>
    createAction(ActionType.SetReceivedTicket, {ticketId}),
  removeExpiredTicket: (ticketId: number) =>
    createAction(ActionType.RemoveExpiredTicket, {ticketId}),
  fetchGiftRedDotStatus: () =>
    createActionFetch(ActionType.FetchGiftRedDotStatus),
};
